import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const useProjectFilters = (categoriesProjets) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedServiceImg, setSelectedServiceImg] = useState(null);
  const [selectedSousService, setSelectedSousService] = useState(null);
  const [showAllProjects, setShowAllProjects] = useState(true);

  useEffect(() => {
    const category = searchParams.get("category");
    const service = searchParams.get("service");
    const sousService = searchParams.get("sousService");
    
    setSelectedCategory(
      category && category !== "undefined"
        ? categoriesProjets?.find(cat => cat?.id == category)
        : null
    );
    setSelectedService(service || null)
    setSelectedSousService(sousService || null);
    setShowAllProjects(!category && !service && !sousService);
  }, [searchParams, categoriesProjets]);
  

  const updateQueryParams = (params) => {
    setSearchParams(params, { replace: true });
  };

  const handleCategorySelect = (category) => {
    if ((selectedCategory?.id === category?.id) && !selectedService) {
      updateQueryParams({});
    } else {
      updateQueryParams({ category: category?.id });
    }
  };
  

  const handleServiceSelect = (service) => {
    setSelectedServiceImg(service?.image);
    updateQueryParams({
      category: service?.categorie_id,
      service: service?.nom_service,
    });
  };

  const handleAllProjectsClick = () => {
    updateQueryParams({});
  };

  const handleSousServiceSelect = (sousServiceName) => {
    updateQueryParams({
      category: selectedCategory?.id,
      service: selectedService,
      sousService: sousServiceName,
    });
  };

  const categoriesWithProjects = categoriesProjets &&
    categoriesProjets?.filter((cat) =>
      cat.services.some((service) =>
        service.sous_services.some(
          (sousService) => sousService?.projets?.length > 0
        )
      )
    ) || [];
  

  const getSelectedServiceSousServices = () => {
    if (!selectedService || !categoriesProjets) return [];

    const category = categoriesProjets?.find((cat) =>
      cat?.services?.some((serv) => serv.nom_service === selectedService)
    );

    if (!category) return [];

    const service = category?.services?.find(
      (serv) => serv.nom_service === selectedService
    );
    return service?.sous_services.filter((ss) => ss.projets?.length > 0) || [];
  };

  const getSelectedCategoryServices = () => {
    const category = categoriesProjets?.find((cat) =>
      cat.id === selectedCategory?.id
    );

    if (!category) return [];

    const services = category?.services

    return services;
  }

  const getFilteredProjects = () => {
    if (!categoriesProjets) return [];

    if (selectedSousService) {
      const category = categoriesProjets?.find((cat) =>
        cat?.services.some((serv) =>
          serv.sous_services.some(
            (ss) => ss.nom_sous_service === selectedSousService
          )
        )
      );

      if (category) {
        const service = category?.services?.find((serv) =>
          serv.sous_services.some(
            (ss) => ss.nom_sous_service === selectedSousService
          )
        );

        if (service) {
          const sousService = service?.sous_services?.find(
            (ss) => ss.nom_sous_service === selectedSousService
          );

          return sousService?.projets || [];
        }
      }
    } else if (selectedService) {
      const category = categoriesProjets.find((cat) =>
        cat?.services.some((serv) => serv?.nom_service === selectedService)
      );
      

      if (category) {
        const service = category?.services?.find(
          (serv) => serv.nom_service === selectedService
        );

        return service.sous_services.flatMap((ss) => ss.projets || []);
      }
    } else if (showAllProjects) {
      return categoriesProjets && categoriesProjets?.flatMap((cat) =>
        cat?.services?.flatMap((serv) =>
          serv?.sous_services?.flatMap((ss) => ss.projets || [])
        )
      );
    } else if (selectedCategory) {
      return selectedCategory?.services?.flatMap((serv) =>
        serv.sous_services.flatMap((ss) => ss.projets || [])
      );
    }

    return [];
  };

  return {
    selectedCategory,
    selectedService,
    selectedSousService,
    showAllProjects,
    categoriesWithProjects,
    getSelectedServiceSousServices,
    getFilteredProjects,
    handleCategorySelect,
    handleServiceSelect,
    handleAllProjectsClick,
    handleSousServiceSelect,
    selectedServiceImg,
    getSelectedCategoryServices
  };
};